import classNames from 'classnames';
import { FunctionComponent } from 'react';

interface IconButtonProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  customPadding?: string;
  white?: boolean;
  circle?: boolean;
}

const IconButton: FunctionComponent<IconButtonProps> = ({
  className,
  customPadding,
  circle = false,
  white = false,
  ...divProps
}) => {
  return (
    <div
      {...divProps}
      className={classNames(
        'flex transform active:scale-90 transition cursor-pointer select-none',
        className,
        {
          'hover:bg-black/5': !white,
          'hover:bg-white/5': white,
          'p-2': !customPadding,
          'rounded-[6px]': !circle,
          'rounded-full': circle,
        },
        customPadding,
      )}
    ></div>
  );
};

export default IconButton;
